// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"55":"bdb5cba5","161":"8602f7a9","284":"ab95ee5c","819":"1790834e"}[chunkId] + ".css";
};